import getInstance from './instance';
import events from './events';
import Data from './data';
import shopperDataLoader from './shopper-data';

const target = typeof document !== 'undefined' ? window : {};
const data = new Data();
const eldorado = {};

target.ux = target.ux || {};
target.ux.eldorado = target.ux.eldorado || eldorado;

//
// Allow external JS to listen to events emitted from the manifests and prepare
// data object.
//
target.ux.eldorado.events = eldorado.events || events;
target.ux.eldorado.data = eldorado.data || data;

//
// Setup listeners to expose mounted instances.
//
target.ux.eldorado.header = getInstance('header');
target.ux.eldorado.footer = getInstance('footer');

// To keep backwards compatibility with Eldorado
if (typeof target.jQuery === 'function') {
  target.ux.jQuery = target.ux.eldorado.jQuery = target.jQuery;
}

/**
 * If jQuery is present on the page, run the specified callback when jQuery is ready.
 * Otherwise, run the callback synchronously
 *
 * @param {Function} cb The callback to run
 * @api private
 */
target.ux._runOnJQueryReady = function runOnJQueryReady(cb) {
  if (target.ux.jQuery) {
    target.ux.jQuery(document).ready(cb);
  } else {
    cb(); // eslint-disable-line callback-return
  }
};

// When the header mounts, make all subsequent calls to ux.eldorado.ready synchronous
target.ux.eldorado.events.once('mount:header', function uxEldoradoReadyOnMountHeader() {
  target.ux.eldorado.ready = function uxEldoradoReadyImmediate(cb) {
    target.ux._runOnJQueryReady(cb);
  };
});

/**
 * Register the specified callback to run when UXCore1 is loaded.
 *
 * Note: If UXCore1 is never loaded (e.g. if the page is using UXCore2), the callback will never run.
 *
 * @param {Function} cb The callback to run
 * @api public
 */
target.ux.ready = function uxReady(cb) {
  target.ux.fns = target.ux.fns || [];
  target.ux.fns.push(cb);
};

/**
 * Register the specified callback to run when the header is mounted.
 *
 * @param {Function} cb The callback to run
 * @api public
 */
target.ux.eldorado.ready = function uxEldoradoReady(cb) {
  target.ux.eldorado.events.once('mount:header', function () {
    target.ux._runOnJQueryReady(cb);
  });
};

// Transfer over all the callbacks that queued up before this script loaded
if (Array.isArray(target.ux.eldorado.readyFns)) {
  target.ux.eldorado.readyFns.forEach(function (fn) {
    target.ux.eldorado.ready(fn);
  });
  target.ux.eldorado.readyFns = null;
}

// Set up shopperData API and handle pre-queued callbacks
if (!target.ux.eldorado._shopperDataLoader) {
  // Create a new ShopperDataLoader
  target.ux.eldorado._shopperDataLoader = shopperDataLoader;

  // Attach it to the existing `shopperData` function
  target.ux.eldorado.shopperData = shopperDataLoader.shopperData.bind(shopperDataLoader);

  // Run all pre-queued callbacks in order
  if (target.ux.eldorado._shopperDataFns) {
    target.ux.eldorado._shopperDataFns.forEach(fn => {
      target.ux.eldorado.shopperData(fn);
    });
  }
}

export {
  events,
  data
};
